import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import AboutUs from "./Components/AboutUs/AboutUs";
import Shop from "./Pages/Shop";
import Cart from "./Pages/Cart";
import Product from "./Pages/Product";
import ShopCategory from "./Pages/ShopCategory";
import LoginSignup from "./Pages/LoginSignup";
import techexpert from "./Components/Assets/techexpert.jpeg";
import purchase from "./Components/Assets/purchase.jpeg";
import aiexpert from "./Components/Assets/aiexpert.jpeg";
import mediaexpert from "./Components/Assets/mediaexpert.jpeg";
import PayPage from "./Components/PayPage/PayPage";
import Contact from "./Components/Contact/Contact";
import TermsAndConditions from "./Components/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "./Components/PrivacyPolicy/PrivacyPolicy";
import RefundPolicy from "./Components/RefundPolicy/RefundPolicy";
// Backend URL (not used for now)
export const backend_url = "http://localhost:4000";
export const currency = "$";

function App() {
  return (
    <div>
      <Router>
        <Navbar />

        <Routes>
          <Route path="/" element={<Shop gender="all" />} />
          <Route
            path="/tech"
            element={<ShopCategory banner={techexpert} category="tech" />}
          />
          <Route
            path="/ai"
            element={<ShopCategory banner={aiexpert} category="ai" />}
          />
          <Route
            path="/media"
            element={<ShopCategory banner={mediaexpert} category="media" />}
          />
                 <Route
            path="/graphics"
            element={<ShopCategory banner={mediaexpert} category="tutorials" />}
          />
          <Route
            path="/tutorials"
            element={<ShopCategory banner={purchase} category="tutorials" />}
          />
          {/* <Route path="/product" element={<Product />}>
          </Route> */}
          <Route path="/cart" element={<Cart />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/pay" element={<PayPage />} />
          <Route path="/login" element={<LoginSignup />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
<Route path="/privacy-policy" element={<PrivacyPolicy />} />
<Route path="/refund-policy" element={<RefundPolicy />} />
        </Routes>

        <Footer />
      </Router>
    </div>
  );
}

export default App;